import { UserNotification } from "./leagueInterfaces";

export enum NotificationTargetType {
  AllUsers = "allUsers",
  AllTeamOwners = "allTeamOwners",
  TeamMembers = "teamMembers",
  AllPlayers = "allPlayers",
  Users = "specificUsers",
  Teams = "specificTeams",
}

export enum NotificationType {
  GeneralNotification = "GENERAL_NOTIFICATION",
  MatchNotification = "MATCH_NOTIFICATION",
  EventNotification = "EVENT_NOTIFICATION",
  SeasonNotification = "SEASON_NOTIFICATION",
}

export enum NotificationMedium {
  Email = "EMAIL",
  SMS = "SMS",
  AppNotification = "APP_NOTIFICATION",
}

export const notificationTypes = [
  {
    value: NotificationType.GeneralNotification,
    label: "General Notification",
  },
  {
    value: NotificationType.MatchNotification,
    label: "Match Notification",
  },
  {
    value: NotificationType.EventNotification,
    label: "Event Notification",
  },
  {
    value: NotificationType.SeasonNotification,
    label: "Season Notification",
  },
];

export const notificationTargetTypes = [
  {
    value: NotificationTargetType.AllUsers,
    label: "All Users",
  },
  {
    value: NotificationTargetType.AllTeamOwners,
    label: "All Team Owners",
  },
  {
    value: NotificationTargetType.TeamMembers,
    label: "Team Members",
  },
  {
    value: NotificationTargetType.AllPlayers,
    label: "All Players",
  },
  {
    value: NotificationTargetType.Users,
    label: "Users",
  },
  {
    value: NotificationTargetType.Teams,
    label: "Teams",
  },
];

export const notificationMediums = [
  {
    value: NotificationMedium.Email,
    label: "Email",
  },
  {
    value: NotificationMedium.SMS,
    label: "SMS",
  },
  {
    value: NotificationMedium.AppNotification,
    label: "App Notification",
  },
];

export const flattenUserNotifications = (
  userNotifications: UserNotification[]
) =>
  userNotifications.map((un) => {
    return {
      ...un,

      title: un.notification?.title,
      message: un.notification?.message,
      type: un.notification?.type,
      targetType: un.notification?.targetType,
      targetIds: un.notification?.targetIds,
      mediumType: un.notification?.mediumType,
      createdDate: un.notification?.createdDate,
      expiryDate: un.notification?.expiryDate,
      isActive: un.notification?.isActive,
      notificationForId: un.notification?.notificationForId,

      seasonName: un.season?.seasonName,
      seasonNumber: un.season?.seasonNumber,
      registrationCutOffDate: un.season?.registrationCutOffDate,
    };
  });
